import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from './sidebar/sidebar.component';
import {NavbarComponent} from './navbar/navbar.component';
import {FooterComponent} from './footer/footer.component';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { FeaturesComponent } from './features/features.component';
import { AboutGeneticComponent } from './about-genetic/about-genetic.component';
import { PriceBoxComponent } from './price-box/price-box.component';
import { ProductPriceComponent } from './product-price/product-price.component';
import {FaqModule} from './mat-faq/faq.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    FeaturesComponent,
    AboutGeneticComponent,
    PriceBoxComponent,
    ProductPriceComponent,

  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    FeaturesComponent,
    AboutGeneticComponent,
    PriceBoxComponent,
    ProductPriceComponent,

  ]
})
export class ComponentsModule { }
